module.exports = __webpack_public_path__ + "static/media/gq.3c96f718.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/gq.svg
// module id = 1051
// module chunks = 0